import { render, staticRenderFns } from "./PatientVisitData.vue?vue&type=template&id=3056a183&scoped=true"
import script from "./PatientVisitData.vue?vue&type=script&lang=js"
export * from "./PatientVisitData.vue?vue&type=script&lang=js"
import style0 from "./PatientVisitData.vue?vue&type=style&index=0&id=3056a183&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3056a183",
  null
  
)

export default component.exports